/**
 * Maps the response of GET /api/scores/event/:id/analysis to the shape
 * that the results page shows.
 *
 * The route returns `{ status, data: { analysis: [...] } }`.
 * Each round item has `roundIndex` (the round orderIndex, 0-based),
 * `roundTitle`, and `questions`.
 */

export interface QuestionStat {
  questionId: string;
  orderIndex: number;
  text: string;
  answer: string;
  correctCount: number;
  totalTeams: number;
  percentCorrect: number;
}

export interface RoundAnalysis {
  /** 1-based round number. It matches the `roundIndex` in standings. */
  roundNumber: number;
  title: string;
  questions: QuestionStat[];
}

interface RawRound {
  roundIndex?: number;
  roundTitle?: string | null;
  questions?: QuestionStat[];
}

/** Returns the rounds from an analysis response body. Returns [] for a bad shape. */
export function mapRoundAnalysis(body: unknown): RoundAnalysis[] {
  const raw = (body as { data?: { analysis?: unknown } } | null | undefined)?.data
    ?.analysis;
  if (!Array.isArray(raw)) return [];
  return (raw as RawRound[]).map((round, i) => ({
    // The route sends the round orderIndex, which starts at 0.
    // Standings and the scoresheet count rounds from 1.
    roundNumber: (typeof round.roundIndex === 'number' ? round.roundIndex : i) + 1,
    title: round.roundTitle ?? '',
    questions: Array.isArray(round.questions) ? round.questions : [],
  }));
}
